import React from "react";
import { FullScreenChatIcon, FullScreenChatCloseIcon } from "../Icons";

const FullScreenSideModuleButton = ({ active, onClick }) => {
    return <a onClick={onClick}>
        {active ? <FullScreenChatCloseIcon /> : <FullScreenChatIcon />}
    </a>
}

export default FullScreenSideModuleButton;